export default __webpack_public_path__ + "static/media/03.16202d5c.png";